import styled, { css } from "styled-components/macro";
import { h4, body14 } from "../../../../../utils/css/typography";

const Title = styled.p`
  ${h4};
`;

const TextWithOpacity = styled.p`
  opacity: 0.5;
  ${body14}
`;

const P = styled.p`
  margin-top: 2rem;
`;

const ulStyle = css`
  padding-left: 0;
  padding-right: 1.3em;
  margin-left: 0;
  margin-right: 0.5em;
`;

const ListMain = styled.ul`
  ${ulStyle};
  list-style-type: disc;
`;

const ListSec = styled.ul`
  ${ulStyle};
  list-style-type: circle;
`;

const LiTitle = styled.span`
  text-decoration: underline;
  font-weight: bold;
`;
const LiTextBold = styled.span`
  font-weight: bold;
`;

const LiTextUnderline = styled.li`
  text-decoration: underline;
`;

export {
  Title,
  P,
  ListMain,
  ListSec,
  LiTitle,
  LiTextBold,
  LiTextUnderline,
  TextWithOpacity,
};
